import { ExternalMobileAuth } from "./ExternalMobileAuth";
import { setJustBootstrapped } from "./useJustBootstrappedMobileAuthentication";
import { ForcedExternalLogoutFlag } from "./ForcedExternalLogoutFlag";

export class MobileBootstrapSessionHandler {
  onSuccess() {
    console.log(
      "[LoginProvider] Mobile bootstrap session successful, reloading page"
    );
    // After successful token exchange, reload the page to trigger full re-authentication
    // This ensures LoginProvider runs checkAccess again and loads the authenticated user
    ForcedExternalLogoutFlag.remove();
    try {
      // Clear sticky external mobile auth flag after handoff completes
      ExternalMobileAuth.removeLocalStorageFlag();
      console.log(
        "[LoginProvider] [DEBUG_LOG] Cleared localStorage.externalMobileAuth after bootstrap"
      );
    } catch {
      // noop
    }
    // Best-effort: notify server to clear cookie fallback
    ExternalMobileAuth.clearCookie();
    setJustBootstrapped();
    // Use replace() to avoid back button taking us to /mobile/bootstrap-session
    window.location.replace("/");
  }
  onError(error: string) {
    console.error("[LoginProvider] Mobile bootstrap session failed:", error);
    // Proactively clear any stale external browser (Safari/Chrome) session and re-enter login
    ForcedExternalLogoutFlag.remove();
    const logoutThenLogin =
      "/identity/logout-browser?externalMobileAuth=1&callback_scheme=minpipe&returnUrl=/login";
    console.log(
      "[LoginProvider] Redirecting to external logout to clear stale session:",
      logoutThenLogin
    );
    window.location.replace(logoutThenLogin);
  }
}
